import { useEffect } from "react";
import routes from "@/seo/routes.json";

const SITE = process.env.REACT_APP_SITE_URL;

const setAttr = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const pageSchema = (path, r, url) => {
  const graph = [{ "@type": "WebPage", "@id": `${url}#webpage`, url, name: r.title, description: r.description, inLanguage: "en-US", isPartOf: { "@id": `${SITE}/#website` }, about: { "@id": `${SITE}/#organization` } }];
  if (path !== "/") graph.push({ "@type": "BreadcrumbList", itemListElement: [{ "@type": "ListItem", position: 1, name: "Home", item: `${SITE}/` }, { "@type": "ListItem", position: 2, name: r.name, item: url }] });
  return { "@context": "https://schema.org", "@graph": graph };
};

export const Seo = ({ path, noindex }) => {
  useEffect(() => {
    const r = routes[path];
    const url = path === "/" ? `${SITE}/` : `${SITE}${path}`;
    const title = r ? r.title : "Page Not Found | VidaVital Medical Franchise";
    document.title = title;
    if (r) {
      setAttr('meta[name="description"]', "content", r.description);
      setAttr('meta[property="og:description"]', "content", r.description);
      setAttr('meta[name="twitter:description"]', "content", r.description);
    }
    setAttr('meta[property="og:title"]', "content", title);
    setAttr('meta[name="twitter:title"]', "content", title);
    setAttr('meta[name="robots"]', "content", noindex || !r || r.noindex ? "noindex, nofollow" : "index, follow");
    setAttr('link[rel="canonical"]', "href", url);
    setAttr('meta[property="og:url"]', "content", url);
    const ld = document.getElementById("ld-page");
    if (ld && r) ld.textContent = JSON.stringify(pageSchema(path, r, url));
  }, [path, noindex]);
  return null;
};
